import { createTheme } from '@mui/material'
import { colors } from 'siteline-common-web/themes/Styles'

declare module '@mui/material/styles' {
  interface Palette {
    ai: Palette['primary']
  }

  interface PaletteOptions {
    ai?: PaletteOptions['primary']
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    ai: true
  }
}

declare module '@mui/material/CircularProgress' {
  interface CircularProgressPropsColorOverrides {
    ai: true
  }
}

const theme = createTheme({
  palette: {
    background: {
      default: '#fafafa',
    },
  },
})

export const prodTheme = createTheme(theme, {
  palette: {
    ai: theme.palette.augmentColor({
      color: {
        main: colors.purple50,
      },
      name: 'ai',
    }),
  },
})

export const devTheme = createTheme(theme, {
  palette: {
    primary: theme.palette.augmentColor({
      color: {
        main: colors.green70,
      },
      name: 'primary',
    }),
    secondary: theme.palette.augmentColor({
      color: {
        main: colors.grey50,
      },
      name: 'secondary',
    }),
    ai: theme.palette.augmentColor({
      color: {
        main: colors.purple50,
      },
      name: 'ai',
    }),
  },
})
